export function articleAnchorLinks(): void {
    document.getElementById("bg-anchor-item-list-title")?.addEventListener('click', () => {
        document.getElementById("bg-anchor-link-content-list")?.classList.toggle("bg-anchor-content-expanded")
    });
}
